module.exports = __webpack_public_path__ + "img/img-deposit-sec-10.png";